<template>
  <div>
    <v-container grid-list-xl v-if="!collected">
      <v-dialog v-model="dialogProgress" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pa-5">
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout column>
        <v-flex v-if="Campaigns">
          <v-card flat>

            <v-stepper vertical v-model="step" class="elevation-0">

              <v-stepper-step class="pl-2" :complete="step > 1" step="1">

                <v-layout row justify-space-between>
                  <v-flex shrink>
                    Sponsor
                  </v-flex>
                  <v-flex shrin v-if="allRowTotal">
                    {{ allRowTotal | currency }}
                  </v-flex>
                </v-layout>
              </v-stepper-step>

            
              
              <v-stepper-content class="pl-1 pt-1 ml-5" step="1">
                <div>
                  <v-list dense class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Name</v-list-item-title>
                      </v-list-item-content>
                      <!-- <v-list-item-action>
                        <v-list-item-title>Amount</v-list-item-title>
                      </v-list-item-action> -->
                      <v-list-item-action>
                        <v-list-item-title>Balance</v-list-item-title>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <div class="mb-2">
                    <v-list dense class="py-0" v-for="(group, index) in group" :key="index">
                      <v-subheader style="background: #EEEEEE;">{{ group.category }}</v-subheader>
                      <v-list-item class="rounded"
                        :class="{ selectedRow: isActive(item), paidRow: (calculateReceivedingPercentage(item.received, item.amount) >= 100 ? true : false), receiveMoney: (item.received > 0 ? true : false) }"
                        v-for="(item, i) in group.items" :key="i" @click="openRow(item)">
                        <v-list-item-icon class="mr-2">
                          <v-progress-circular :size="30" :width="3"
                            v-if="(calculateReceivedingPercentage(item.received, item.amount) >= 100 ? false : true)"
                            :value="calculateReceivedingPercentage(item.received, item.amount)" color="teal">
                            <span class="caption">{{ calculateReceivedingPercentage(item.received, item.amount)
                              }}</span>
                          </v-progress-circular>
                          <v-icon v-else size="30" color="teal">mdi-check-circle-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }} <span class="caption"
                              v-if="item.received > 0 ? true : false"> - {{ item.received | currency }} Received</span>
                            <v-chip class="ml-1"
                              v-if="(calculateReceivedingPercentage(item.received, item.amount) >= 100 ? true : false)"
                              small>RESERVED</v-chip> </v-list-item-title>
                          <v-list-item-subtitle v-if="item.donationAmount">{{ item.donationAmount | currency
                            }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <!-- <v-list-item-action>
                          <v-list-item-title> {{ item.amount | currency }}</v-list-item-title>
                        </v-list-item-action> -->
                        <v-list-item-action>
                          <v-list-item-title> {{ item.amount - item.received | currency }}</v-list-item-title>
                        </v-list-item-action>



                      </v-list-item>
                    </v-list>
                  </div>
                  <v-card color="green lighten-4" class="py-2" flat>
                    <div class="text-center">Your Donation Total <span class="font-weight-bold">{{ allRowTotal |
      currency }}</span> </div>
                  </v-card>

                </div>

                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                  <v-btn text @click="$router.go(-1)">Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn large @click="infoStep" :disabled="!allowStep2" color="primary">Next</v-btn>
                </v-card-actions>
              </v-stepper-content>

              <v-stepper-step class="pl-2" :complete="step > 2" step="2">
                Your Information
              </v-stepper-step>

              <v-stepper-content class="pl-1 pt-1 ml-5" step="2">
                <v-layout row wrap class="mt-2">
                  <v-flex xs12 sm6>
                    <v-text-field autofocus v-model="Donor.name" :error-messages="nameErrors"
                      :hide-details="nameErrors.length === 0" outlined dense label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field type="number" :error-messages="phoneNumberErrors"
                      :hide-details="phoneNumberErrors.length === 0" v-model="Donor.phoneNumber" outlined dense
                      label="Phone Number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="Donor.email" :error-messages="emailErrors"
                      :hide-details="emailErrors.length === 0" outlined dense label="Email Address"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                  <v-btn text @click="step = step - 1" large>Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn large @click="paymentInfo" color="primary">Next</v-btn>
                </v-card-actions>
              </v-stepper-content>


              <v-stepper-step class="pl-2" :complete="step > 3" step="3">
                Payment
              </v-stepper-step>

              <v-stepper-content class="pl-1 pt-1 ml-5" step="3">


                <CreditCard v-if="step === 3" @submit="infoCollect" :localCollectOnly="true" :donor="Donor"
                  :public="true" :donationCategoryId="Business.DefaultDonationId"/>


                <p class="mt-5" v-if="Business">
                  By clicking the "Submit" button, you are authorizing an electronic fund transfer from the specified
                  account
                  for this transaction in the specified amount to {{ Business.name }}.
                </p>

                <!-- :disabled="loading" :loading="loading" -->
                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                  <v-btn text @click="step = step - 1" large>Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn large @click="submit" :disabled="loading" :loading="loading" rounded class="px-5"
                    color="primary">Donate {{
      totalDonationAmount | currency
    }}</v-btn>
                </v-card-actions>
              </v-stepper-content>

            </v-stepper>




          </v-card>
          <!-- <div class="text-right">
            Power by: <span>taleem.app</span> -
            <span class="caption">{{ version }}</span>
          </div> -->


        </v-flex>
      </v-layout>

      <v-dialog v-model="dialog" width="480" persistent>

        <v-card v-if="selectedRow">
          <v-card-title class="text-h5 grey lighten-2">
            <v-layout row wrap class="py-3">
              <v-flex>
                {{ selectedRow.name }}
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <v-btn text icon @click="close">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-card-text class="pt-4">
            <v-layout column>
              <v-flex>
                <!-- calculateReceivedingPercentage(item.received, item.amount) -->
                <span class="text-h4 black--text font-weight-light">{{ selectedRow.received | currency }}</span>
                <span> raised of {{ selectedRow.amount | currency }} goal</span>
              </v-flex>
              <v-flex>
                <v-progress-linear
                  :value="calculateReceivedingPercentage(selectedRow.received, selectedRow.amount)"></v-progress-linear>
                <!-- <div>27 donations</div> -->
              </v-flex>


            </v-layout>

          </v-card-text>
          <v-card-text>
            <v-row>
              <!-- <v-col cols="12">
                <v-btn block rounded large color="success" @click="paidInFull"> Reserved Full Day For {{
      paidInFullAmount
      | currency }} </v-btn>
              </v-col>
              <v-col cols="12">
                <div class="text-center font-weight-bold black--text">OR</div>
              </v-col> -->
              <v-col cols="12">
                <div class="font-weight-regular black--text">Choose an Amount or Enter Custom Amount <span
                    class="red--text">*</span></div>
              </v-col>


              <v-col cols="12">
                <v-btn block large color="success" @click="paidInFull"> Reserved Full Day For {{
      paidInFullAmount
      | currency }} </v-btn>
              </v-col>

              <v-col cols="12">
                <!-- <v-row>
                  <v-btn color="success" @click="paidInFull" class="ma-1"> {{ paidInFullAmount | currency }} </v-btn>
                </v-row> -->

                <v-btn-toggle active-class="custom-active-class" dense mandatory v-model="donationSelectedAmount"
                  color="primary" group>
                  <v-row>

                    <v-btn v-for="amount in preDefinedValue" :key="amount" outlined class="ma-1">
                      {{ amount | currency }}
                    </v-btn>
                  </v-row>
                  <v-row>

                  </v-row>
                </v-btn-toggle>

              </v-col>

              <v-col cols="12">
                <v-text-field class="ar-r" prefix="$" v-model="selectedRow.donationAmount" outlined dense
                  label="Donation Amount" type="number" hide-details></v-text-field>
              </v-col>
            </v-row>



          </v-card-text>

          <v-divider></v-divider>

          <v-btn block x-large style="border-radius: 0 !important;" @click="submitDay" color="success">Submit</v-btn>


        </v-card>
      </v-dialog>

    </v-container>
    <v-container grid-list-lg :fluid="$vuetify.breakpoint.xsOnly" v-else>
      <v-card flat>
        <v-card-text>
          <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation"
            @onComplete="showHomeButton = true" />
          <div class="text-center">
            <div class="text-h5">All Set</div>
            <div class="mt-3">
              The Prophet, upon be peace, said: “The believer’s shade on the Day of Resurrection will be his charity.”
              <span class="font-weight-bold">Al-Tirmidhi</span>
            </div>
          </div>
          <div class="text-center mt-5" v-if="showHomeButton">
            <v-slide-y-transition>
              <v-btn block large @click="$router.go(-1)" color="success">Home</v-btn>
            </v-slide-y-transition>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import donationService from "@/modules/Campaign/service.js";
import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/1708-success.json";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");


export default {
  name: 'collectDonationByCampaign',
  data() {
    return {
      dialogProgress: false,
      donationLimit: false,
      paidInFullAmount: 0,
      allRowTotal: 0,
      donationSelectedAmount: 0,
      dialog: false,
      selectedRow: null,
      Donor: {
        name: null,
        phoneNumber: null,
        email: null,
      },
      menu1: false,
      dateFormatted: null,
      startingDate: this.$moment().add(1, 'day'),
      minDate: null,
      donationObj: {
        paymentType: 'card',
        paymentCycle: 'monthly',
        accountType: 'personal',
        startingDate: this.$moment().add(1, 'day'),
      },
      group: [],
      collected: false,
      card: null,
      showHomeButton: false,
      showSecondCollection: true,
      fridays: ['26', '52', '78', '90', '115'],
      months: ['6', '12', '18', '24', '36'],
      numberOfMonth: '12',
      numberOfFriday: '52',
      loading: false,
      feeAmount: 0,
      allowStep2: false,
      totalDonationAmount: 0,
      step: 1,
      selectedAmount: 0,
      amount: 10,
      paymentCycle: 'monthly',
      Campaigns: null,
      Business: null,
      addFee: false,
      addFeeSecond: false,
      preDefinedValue: ['10', '20', '50', '100', '150', '200'],
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
    }
  },
  created() {
    this.loadCampaign()
  },
  mixins: [validationMixin],
  validations: {
    Donor: {
      name: {
        required,
      },
      phoneNumber: {
        required,
      },
      email: {
        required,
        email
      },
    },
  },
  components: {
    CreditCard,
    Lottie,
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Donor.name.$dirty) return errors;
      if (!this.$v.Donor.name.required)
        errors.push("First Name is required");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.Donor.phoneNumber.$dirty) return errors;
      if (!this.$v.Donor.phoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.Donor.email.$dirty) return errors;
      if (!this.$v.Donor.email.required)
        errors.push("Email Address is required");
      if (!this.$v.Donor.email.email)
        errors.push("Email is not valid");
      return errors;
    },
  },
  watch: {
    allRowTotal(val) {
      if (val > 0) {
        this.allowStep2 = true
      } else {
        this.allowStep2 = false
      }
    },
    dialog(val) {
      if (val) {
        if (this.selectedRow.received) {
          this.paidInFullAmount = parseFloat(this.selectedRow.amount) - parseFloat(this.selectedRow.received)
        } else {
          this.paidInFullAmount = parseFloat(this.selectedRow.amount)
        }
        this.preDefinedValue.push(this.paidInFullAmount)
      }
    },
    addFeeSecond() {
      console.log('click me')
      this.setDonationAmount()
    },
    addFee(val) {
      if (val) {
        this.showSecondCollection = false
      } else {
        this.showSecondCollection = true
      }
      this.setDonationAmount()
    },
    amount() {
      this.setDonationAmount()
    },
    selectedAmount() {
      this.showOtherInput()
    },
    donationSelectedAmount(val) {
      // console.log('donationSelectedAmount', val)
      this.selectedRow.donationAmount = this.preDefinedValue[val]
    }
  },
  methods: {
    reCalculateFee() {
      this.feeAmount = ((parseFloat(this.allRowTotal) * 3.4 / 100) + .30).toFixed(2)


      if (this.addFee || this.addFeeSecond) {
        this.totalDonationAmount = parseFloat(this.allRowTotal) + parseFloat(this.feeAmount)

      }

      this.totalDonationAmount = parseFloat(this.allRowTotal)
    },
    paidInFull() {
      this.selectedRow.donationAmount = this.paidInFullAmount
      this.submitDay()
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    calculateReceivedingPercentage(receivedingAmount, totalAmount) {
      // Calculate the percentage
      let receive = 0
      if (receivedingAmount) {
        receive = receivedingAmount
      }
      const percentage = (receive / totalAmount) * 100;

      // Return the percentage, rounded to 2 decimal places
      return parseFloat(percentage.toFixed(0));
    },
    isActive(item) {
      let value = false
      if (item.donationAmount > 0) {
        value = true
      }
      return value
    },
    reset() {
      this.donationSelectedAmount = 0
      // this.selectedRow.donationAmount = 10
      this.preDefinedValue = ['10', '20', '50', '100', '150', '200']
    },
    close() {
      this.reset()
      this.dialog = false
      this.setDonationAmount()
    },
    submitDay() {
      // console.log('submit day', this.selectedRow)
      // console.log('group', this.group)
      this.group.map(cateogry => {
        cateogry.items.map(row => {
          if (row.id === this.selectedRow.id) {
            // console.log('founded', row)
            row.donationAmount = this.selectedRow.donationAmount
          }
        })
      })
      this.close()
      this.$forceUpdate();
    },
    openRow(item) {
      this.selectedRow = JSON.parse(JSON.stringify(item))
      this.selectedRow.donationAmount = 10
      // console.log('this.selectedRow', item)
      // console.log('this.calculateReceivedingPercentage', this.calculateReceivedingPercentage(item.received, item.amount))
      if (this.calculateReceivedingPercentage(item.received, item.amount) < 100) {
        this.dialog = !this.dialog
      } else {
        this.$swal.fire({
          title: item.name,
          text: "Reserved and paid in full",
          icon: "info"
        })
      }

    },
    groupByCategory(data) {
      const result = [];

      // Create an object to hold grouped items temporarily
      const temp = {};

      // Loop through the data array
      data.CampaignDetails.forEach(item => {
        const { category, id, name, amount, received } = item;

        // If the category doesn't exist in the temp object, create an array for it
        if (!temp[category]) {
          temp[category] = [];
        }

        // Push the name and amount pair to the category array
        if (this.donationLimit) {
          temp[category].push({ id, name, amount, received, donationAmount: 0 });
        } else {
          temp[category].push({ id, name, amount, qty: 0 });
        }

      });

      // Convert temp object to array of objects
      for (const category in temp) {
        result.push({ category, items: temp[category] });
      }

      return result;
    },
    infoCollect(val) {
      this.card = val
    },
    submit() {
      // console.log('submit press')
      try {
        let data = {};
        data.Donor = this.Donor

        // data.ProductId = this.selectedCategory.id
        // data.productName = this.selectedCategory.name
        this.$events.emit("submitCreditCard");
        // console.log('test', test)
        data.donationLimit = this.donationLimit
        // data.cycle = this.paymentCycle
        // data.numberOfMonth = this.numberOfMonth
        // data.numberOfFriday = this.numberOfFriday
        data.Donor = this.Donor
        data.card = this.card
        data.campaignType = this.Campaigns.type
        data.selectedRow = []


        if (this.addFee || this.addFeeSecond) {
          data.processingFeeCollect = true
        } else {
          data.processingFeeCollect = false
        }
        this.group.map(cateogry => {
          cateogry.items.map(row => {
            if (row.donationAmount > 0) {
              // console.log('founded', row)
              data.selectedRow.push(row)
            }
          })
        })
        data.amount = this.allRowTotal
        data.feeAmount = this.feeAmount

        if (data.processingFeeCollect) {
          data.finalAmount = parseFloat(data.amount) + parseFloat(data.feeAmount)
        } else {
          data.finalAmount = parseFloat(data.amount)
        }

        data.CampaignId = this.Campaigns.id

        console.log('data collected', this.Campaigns)
        console.log('data collected data', data)

        if (!data.card) {
          return false
        }
        this.loadingSubmit = true;
        this.loading = true
        this.dialogProgress = true
        donationService
          .publicDonationNoLimit(this.Business.code, data)
          .then((response) => {
            console.log("response publicSponsorCreate", response);
            this.loadingSubmit = false;
            this.collected = true
            this.loading = false
          })
          .catch((error) => {
            this.loadingSubmit = false;
            this.loading = false;
            this.dialogProgress = false
            console.log("err", error);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });

      } catch (error) {
        this.dialogProgress = false
        this.loadingSubmit = false;
        this.loading = false;
        console.log("error adding card3", error);
      }
    },
    paymentInfo() {
      this.$v.Donor.$touch();
      if (this.$v.Donor.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.step = 3
      }

      // console.log('this.Campaigns.metadata.donationLimit', this.Campaigns.metadata.donationLimit)
      // if (this.Campaigns.metadata.donationLimit) {
      //   console.log('stop 3')
      //   this.step = 4
      // } else {
      //   console.log('stop 4')
      //   this.step = 3
      // }

    },
    showOtherInput() {
      this.amount = this.preDefinedValue[this.selectedAmount]
    },
    setDonationAmount() {
      if (this.Campaigns.type === 'sponsor') {
        if (this.step === 1 && this.group.length) {
          this.allRowTotal = 0
          this.group.map(category => {
            category.items.map(row => {
              if (row.donationAmount) {
                this.allRowTotal += parseFloat(row.donationAmount)
              }
              if (!this.donationLimit && row.qty > 0) {
                this.allRowTotal += parseFloat(row.amount) * row.qty
              }
            })
          })
        }
        this.feeAmount = 0
        this.reCalculateFee()

      } else {
        if (this.amount > 0) {
          this.feeAmount = (parseFloat(this.amount) * 3.4 / 100) + .30
          this.allowStep2 = true
        } else {
          this.feeAmount = 0
          this.allowStep2 = false
        }
        if (this.addFee || this.addFeeSecond) {
          this.totalDonationAmount = parseFloat(this.amount) + parseFloat(this.feeAmount)
        } else {
          this.totalDonationAmount = parseFloat(this.amount)
        }
      }

    },
    infoStep() {
      this.step = 2
    },
    loadCampaign() {
      let code = this.$route.params.id
      console.log('getting code 22', this.$route.params)
      donationService
        .getCampaignById(code)
        .then((response) => {
          console.log("response campaign", response);
          // if (!response.data) {
          //   this.$router.push({ name: "pagenotfound" });
          // }
          this.Campaigns = response.data
          this.Business = response.data.Business
          console.log('test', this.Campaigns.metadata.preDefinedValue)
          if (this.Campaigns?.metadata?.preDefinedValue.length) {
            this.preDefinedValue = this.Campaigns.metadata.preDefinedValue
            this.amount = this.preDefinedValue[0]
          }
          if (this.Campaigns && this.Campaigns.metadata && this.Campaigns.metadata.donationLimit) {
            this.donationLimit = true
          }


          this.group = this.groupByCategory(this.Campaigns)
          // console.log('this.group', this.group)

        })
        .catch((error) => {
          console.log("error getting campaign", error);
          // this.$router.push({ name: "pagenotfound" });
        });
    }
  }
}
</script>

<style scoped>
.selectedRow {
  background: #B2DFDB;
  font-weight: 900 !important;
}

.paidRow {
  background: #E1BEE7;
  /* font-weight: 900 !important; */
}

.receiveMoney {
  background: #E8F5E9;
  /* font-weight: 900 !important; */
}
</style>../../../../../package.json